import { render } from "./ModalContainer.vue?vue&type=template&id=0b8f7966"
import script from "./ModalContainer.vue?vue&type=script&lang=js"
export * from "./ModalContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__